import React, { useState, useRef, useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import { contactUsFormStyles } from './ContactUsForm.styles';
import ContactForm from './ContactForm/ContactForm';
import Header from '../Header/Header';

const ContactUsForm = ({showHeader = false}) => {
  const [isInView, setIsInView] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isInView) {
            setIsInView(true);
          }
        });
      },
      {
        threshold: 0.1
      }
    );

    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [isInView]);

  const styles = contactUsFormStyles(isInView);

  return (
    <Box ref={containerRef} sx={styles.container}>
        {
          showHeader && (
            <Box sx={styles.headerContainer}>
              <Header secondaryButton={true} />
            </Box>
          )
        }
      <Grid container sx={styles.gridContainer} pt={0} >
        <Grid size={{ xs: 12, md: 6.5 }} sx={styles.leftColumn} pt={{xs: showHeader ? {xs: 0 , md: "150px"} : 0, lg: 0}}>
          <ContactForm isInView={isInView} showHeader={showHeader} />
        </Grid>
        <Grid size={{ xs: 12, md: 5.5 }} sx={styles.rightColumn}>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactUsForm;

